<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
      <ValidationProvider :name="$t('labels.country')" rules="required" v-slot="{ errors }">
        <VueCountryIntl
          class="country-select"
          :class="{'country-select-error': errors[0]}"
          disableCountry="Malaysia"
          :show-label-img="false"
          :show-area-code="false"
          v-model="form.country"
          type="country"
          :placeholder="$t('common.selectCountry')"
          :error-messages="errors[0]"
        ></VueCountryIntl>
        <div class="error-text px-3">{{errors[0]}}</div>
      </ValidationProvider>

      <ValidationProvider ref="email" :name="$t('labels.email')" rules="required|email" v-slot="{ errors }">
        <v-text-field
          v-model.trim="form.email"
          single-line
          outlined
          :label="$t('labels.email')"
          flat
          dense
          clearable
          :error-messages="errors[0]"
        ></v-text-field>
      </ValidationProvider>

      <ValidationProvider :name="$t('labels.pwd')" rules="required|pwdRule" vid="confirmation" v-slot="{ errors }">
        <v-text-field
          v-model.trim="form.password"
          :type="pwdShow ? 'text' : 'password'"
          :append-icon="pwdShow ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="pwdShow = !pwdShow"
          single-line
          outlined
          :label="$t('labels.pwd')"
          flat
          dense
          clearable
          :error-messages="errors[0]"
        ></v-text-field>
      </ValidationProvider>

      <ValidationProvider :name="$t('labels.confirmPwd')" rules="required|confirmed:confirmation" v-slot="{ errors }">
        <v-text-field
          v-model.trim="form.secondPwd"
          :type="conPwdShow ? 'text' : 'password'"
          :append-icon="conPwdShow ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="conPwdShow = !conPwdShow"
          single-line
          outlined
          :label="$t('labels.confirmPwd')"
          flat
          dense
          clearable
          :error-messages="errors[0]"
        ></v-text-field>
      </ValidationProvider>

      <div class="code-btn-container">
        <ValidationProvider :name="$t('labels.otp')" rules="required|otpRule" v-slot="{ errors }">
          <v-text-field
            v-model.trim="form.otp"
            single-line
            outlined
            :label="$t('labels.otp')"
            flat
            dense
            :error-messages="errors[0]"
          ></v-text-field>
        </ValidationProvider>
        <VerifyBtn
          type="register"
          :value="form.email"
          :geetest="true"
          :onProgressText="$t('common.verifyCount')"
          :condition="getVerifyCodeByEmailCondition"
        ></VerifyBtn>
      </div>

      <ValidationProvider :name="$t('register.inviteCode')" v-slot="{ errors }">
        <v-text-field
          v-model.trim="form.refCode"
          single-line
          outlined
          :label="$t('register.inviteCode')"
          flat
          dense
          clearable
          :error-messages="errors[0]"
        ></v-text-field>
      </ValidationProvider>

      <div class="mb-3" v-html="$t('register.termAndUsePrivacyPolicy')"></div>

      <div class="submit-container mb-3">
        <v-btn
          :loading="commitLoading"
          @click="geetestVerify"
          block
          class="btn-common"
          x-large
          :large="$vuetify.breakpoint.xsOnly"
        >
          {{ $t('actions.registNow') }}
        </v-btn>
      </div>
      <div class="regist-txt">
        {{ $t('register.alreadyRegist') }}
        <router-link to="/login">
          {{ $t('actions.loginNow') }}
        </router-link>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
import geetestMixin from '@/common/mixin/geetest';
import { mapActions, mapMutations } from 'vuex';
import { actionTypes } from '@/store/action-types';
import { mutationTypes } from '@/store/mutation-types';
import { accountApi } from '@/api/accountApi';
import { simpleCookie } from '@/common/js/simpleCookie';

export default {
  components: { VerifyBtn },
  mixins: [geetestMixin],
  data() {
    return {
      curTab: 'email-regist',
      pwdShow: false,
      conPwdShow: false,
      commitLoading: false,
      form: {
        email: '',
        otp: '',
        password: '',
        secondPwd: '', // 第二次输入的密码。仅供本地对照使用。
        // 邀请码，可选填写。
        refCode: '',
        country: '' // Hard coded for now, need to remove
      }
    };
  },
  methods: {
    ...mapMutations([
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_EXPIRETIME,
      mutationTypes.SET_LASTUPDATETIME
    ]),
    ...mapActions([actionTypes.GET_USERINFO_ACTION]),

    async getVerifyCodeByEmailCondition() {
      let valid = await this.$refs.email.validate();
      if (!valid) {
        return false;
      }
      return true;
    },
    geetestVerify() {
      // 判断 是否开启极验
      if (this.showGeetest) {
        this.captchaObj.verify();
      } else {
        this.registSubmit();
      }
    },
    // 极验行为验证通过回调
    captchaSuccessFun() {
      this.registSubmit();
    },
    // 注册的提交。
    async registSubmit() {
      // 显示验证码
      const valid = await this.$refs.observer.validate();
      if (!valid) {
        return;
      }

      let form = this.form;
      let registData = {
        password: form.password,
        // 邀请码，如果存在的话，可以填写。
        refCode: form.refCode,
        // sign变量，将被添加到 Header。
        // sign: this.sign,
        country: form.country.toUpperCase()
      };
      if (this.curTab === 'email-regist') {
        registData.email = this.form.email;
        registData.otp = this.form.otp;
      } else if (this.curTab === 'mobile-regist') {
        registData.mobile = this.form_phone.mobile;
        registData.otp = this.form_phone.otp;
        registData.phoneCode = '+' + this.form_phone.countryCode;
      }
      this._requestRegist(registData, this.captchaSuccess || {});
    },
    // 正式发起，注册请求。
    async _requestRegist(registData) {
      this.commitLoading = true;
      accountApi
        .regist(registData)
        .then(res => {
          this.successNotify(this.$t('register.success'));
          this.commitLoading = false;
          window.localStorage.setItem('firstLogin', 'true');
          this.processLoginSuccess(res.data);
          this.$router.push({ name: 'home' });
        })
        .catch(() => {
          this.commitLoading = false;
          this.initGeetest();
        });
    },
    processLoginSuccess(data) {
      simpleCookie.setItem('isLogin', true);
      // 以秒为单位
      this.SET_LASTUPDATETIME(new Date().getTime() / 1000);
      this.SET_EXPIRETIME(data.expire);
      this.SET_TOKEN(data.accessToken);
      this.SET_USERNAME(data.userName);
      this.GET_USERINFO_ACTION();
    }
  },
  mounted() {
    let inviteCode = this.$route.query.inviteCode;
    if (inviteCode) {
      this.form.refCode = inviteCode;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../../regist.scoped.styl';

.country-select {
  ::v-deep .country-intl-label {
    overflow-x: auto;
    overflow-y: hidden;
  }
  &-error {
    ::v-deep .country-intl-input {
      border: 2px solid rgb(255, 82, 82);
      border-radius: 4px;
    }
  }
}

.code-btn-container {
  position: relative;

  .v-input::v-deep {
    .v-input__control {
      .v-input__slot {
        padding-right: 75px;
      }
    }
  }

  .verify-btn {
    position: absolute;
    top: 12px;
    right: 10px;
    padding: 0;
    border: none;
    height: initial;
    line-height: initial;
    background-color: transparent;
  }
}
</style>
